import { Chip } from "primereact/chip"

const Indicadores = ({ indicadores,templateBooleanIcon,filtros }) => {
    // Función para formatear valores de moneda
    const formatCurrency = (value) => {
        return `$${value.toLocaleString('es-MX', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
    };
    return (
        <div className="indicadores-inline-container">
            {filtros.operador?<Chip label={`Operador: ${indicadores.operador}`} icon="pi pi-user" className="indicador-chip operador-chip" />:""}
            <Chip label={`Empresarial: ${indicadores.empresarial}`} className="indicador-chip" />
            <Chip label={`Especiales: ${indicadores.especiales}`} className="indicador-chip" />
            <Chip label={`KM Total: ${indicadores.kmTotal}`} className="indicador-chip" />
            <Chip label={`Taller: ${indicadores.taller}`} className="indicador-chip" />
            <Chip label={`Sueldo Garantía: ${formatCurrency(indicadores.sueldoGarantia)}`} className="indicador-chip" />
            <Chip label={`Días: ${indicadores.dias}`} className="indicador-chip" />
            <Chip label={<span>Domingo: {templateBooleanIcon(indicadores.domingo)}</span>} className="indicador-chip" />

            {indicadores.domingo && (
                <>
                    <Chip label={`Viajes Dom. Emp.: ${indicadores.viajesDomingoEmpresarial}`} className="indicador-chip" />
                    <Chip label={`Pago Dom. Emp.: ${formatCurrency(indicadores.pagoDomingoEmpresarial)}`} className="indicador-chip" />
                    <Chip label={`Bono Dom. Emp.: ${formatCurrency(indicadores.bonoDomingoEmpresarial)}`} className="indicador-chip" />
                </>
            )}
        </div>
    )
}
export default Indicadores